"use strict";

exports.__esModule = true;
exports.MetricValueFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Metrics = require("../../../Catalogs/Metrics");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Translator = require("../../Core/Translator");
var _MetricSelector = require("../../Metrics/MetricSelector");
var _excluded = ["onChange", "value"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var MetricSelectorAdaptor = function MetricSelectorAdaptor(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var selectedItem = value && (0, _Metrics.getMetricDefinition)(value);
  return /*#__PURE__*/_react["default"].createElement(_MetricSelector.MetricSelector, _extends({
    onSelect: function onSelect(selected) {
      return onChange(selected.length > 0 ? selected[0].name : undefined);
    },
    selected: selectedItem ? [selectedItem] : []
  }, extra));
};

/**
 * Fields for MetricValueElement.
 */
var MetricValueFields = exports.MetricValueFields = function MetricValueFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("MetricValueFields.metricName.label", "Metric")
  }, /*#__PURE__*/_react["default"].createElement(MetricSelectorAdaptor, {
    "data-testid": "MetricValueFields.MetricSelectorSelector",
    value: element.props.metricName,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "metricName", value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricValueFields.showMetricTarget.switch",
    labelElement: translate("MetricValueFields.showMetricTarget.label", "Show Target"),
    checked: element.props.showTarget || false,
    onChange: function onChange(event) {
      return elementEditor.setProp(path, "showTarget", event.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricValueFields.hideLabel.switch",
    checked: element.props.hideLabel || false,
    label: translate("MetricValueFields.hideLabel.label", "Hide Label"),
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideLabel", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Consumer, null, function (layoutSettings) {
    return layoutSettings.selection.allowReportingPeriod && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("MetricValueFields.dataRange.label", "Data Range"),
      helperText: translate("MetricValueFields.dataRange.helperText", "The data range to use when calculating the metric value.")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", {
      "data-testid": "MetricValueFields.dataRange.reportingPeriod.selector",
      value: element.props.dataRange || "",
      onChange: function onChange(e) {
        elementEditor.setProp(path, "dataRange", e.target.value || undefined);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: ""
    }, translate("MetricValueFields.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "SELECTION"
    }, translate("MetricValueFields.dataRange.selection.label", "Selection")))));
  }));
};